// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Portfolio toevoegen',
    copy_custom_fields_label: 'Kopieer aangepaste velden van het bovenliggende portfolio',
    delete_portfolio_title: 'Portfolio {0} verwijderen?',
    DeletionIsUsedDisabled: 'Status kan niet worden verwijderd omdat er een portfolio bestaat met deze status.',
    Editor: 'Portefeuille-editor',
    Manager: 'Portefeuillemanager',
    members: '1#{0} portefeuillelid#{0} portefeuilleleden',
    new_portfolio: 'Nieuw portfolio',
    NewStatusTitle: 'Status toevoegen',
    ParentPortfolio: 'Bovenliggend portfolio',
    permissions_title: 'Dit toegangsniveau heeft de volgende machtigingen met betrekking tot het portfolio en de projecten erin.',
    Portfolios: 'Portefeuilles',
    role_for_this_portfolio: 'Toegangsniveau voor dit portfolio:',
    Statuses: 'Statussen',
    Teamer: 'Portefeuille deelnemer',
    Viewer: 'Portefeuille kijker',
};
